import React from "react";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import { Topic } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { useLanguage } from "../../../../contexts";

const topicController = new Topic();

export function TopicForm({ topic, close, onReload }) {
  const { accessToken } = useAuth();
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const formik = useFormik({
    initialValues: {
      name:        topic?.name        || "",
      description: topic?.description || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("El nombre es obligatorio"),
    }),
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if (topic) {
          await topicController.updateTopic(accessToken, topic._id, values);
          toast.success("Tema actualizado");
        } else {
          await topicController.createTopic(accessToken, values);
          toast.success("Tema creado");
        }
        onReload();
        close();
      } catch (err) {
        toast.error(err?.msg || "Error al guardar");
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit} style={{ padding: "0.5rem" }}>
      <ToastContainer position="top-center" autoClose={800} hideProgressBar />
      <Form.Input
        label={<label>{t("name")} <span style={{ color: "#C0392B" }}>*</span></label>}
        name="name"
        value={formik.values.name}
        onChange={(e) => {
          const v = e.target.value;
          formik.setFieldValue("name", v.charAt(0).toUpperCase() + v.slice(1));
        }}
        error={formik.errors.name}
        placeholder="Ej: Primeros auxilios básicos"
      />
      <Form.TextArea
        label={`${t("description")} (${t("optional")})`}
        name="description"
        value={formik.values.description}
        onChange={(e) => formik.setFieldValue("description", e.target.value)}
        placeholder="Descripción breve del tema..."
        rows={3}
      />
      <div style={{ display: "flex", justifyContent: "center", gap: "14px", marginTop: "2rem" }}>
        <button type="submit" disabled={formik.isSubmitting} style={{ background: "#4A7FA5", color: "#fff", border: "none", borderRadius: "20px", padding: "10px 30px", fontSize: "14px", fontWeight: 600, fontFamily: "'Archivo', sans-serif", cursor: "pointer", opacity: formik.isSubmitting ? 0.55 : 1 }}>
          {formik.isSubmitting ? "…" : (topic ? t("update") : t("save"))}
        </button>
        <button type="button" onClick={close} style={{ background: "#9BAFC4", color: "#fff", border: "none", borderRadius: "20px", padding: "10px 30px", fontSize: "14px", fontWeight: 600, fontFamily: "'Archivo', sans-serif", cursor: "pointer" }}>{t("cancel")}</button>
      </div>
    </Form>
  );
}
